import gql from 'graphql-tag';

const GET_TERMS = gql`
  query getTerms($isLoggedIn: Boolean!) {
    me {
      details @include(if: $isLoggedIn) {
        id
      }
      layout {
        giftingTerms: vcmsAsset(
          structure: "TextAsset"
          properties: { key: "giftingTermsAndConditions" }
          throwError: false
        )
        navigation {
          isWithIcons
          isWithRefreshments
        }
      }
    }
  }
`;

export default GET_TERMS;
